import * as PDFJS from 'pdfjs-dist'
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
import { ResizeImage } from './imageService'

export function toImage(file) {
  return new Promise(resolve => {
    let fileReader = new FileReader()
    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker
    PDFJS.disableWorker = true

    fileReader.onload = async function () {
      let typedarray = new Uint8Array(this.result)

      const loadingTask = PDFJS.getDocument(typedarray)
      const pdf = await loadingTask.promise
      const promises = []
      for(let i = 1; i <= pdf.numPages; i++) {
        let promise = getPage(pdf, i)
        promises.push(promise)
      }
      Promise.all(promises).then(result => {
        resolve(result)
      })
    }

    fileReader.readAsArrayBuffer(file)
  })
}

function getPage(pdf, page) {
  return new Promise(resolve => {
    pdf.getPage(page).then(async page => {
      let viewport = page.getViewport({ scale: 3 })

      let canvas = document.createElement('canvas'),
          context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width

      page.render({ canvasContext: context, viewport: viewport }).promise.then(async function() {
        let resizedBase64 = await ResizeImage(canvas.toDataURL())
        resolve(resizedBase64)
      })
    })
  })
}

export function toText(file, type) {
  return new Promise(resolve => {
    let fileReader = new FileReader()
    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker
    PDFJS.disableWorker = true

    fileReader.onload = async function () {
      let typedarray = new Uint8Array(this.result)

      const loadingTask = PDFJS.getDocument(typedarray)
      const pdf = await loadingTask.promise
      const promises = []
      for(let i = 1; i <= pdf.numPages; i++) {
        let page = pdf.getPage(i)

        promises.push(page.then(function(page) {
          let textContent = page.getTextContent()
          return textContent.then(function(text){
            let textItems = text.items
            let finalString = ""
            let line = 0

            for (let i = 0; i < textItems.length; i++) {
              if (line != textItems[i].transform[5]) {
                if (line != 0) {
                  finalString +='\n'
                }

                line = textItems[i].transform[5]
              }                     
              let item = textItems[i]

              finalString += item.str
            }

            return finalString
          })
        }))
      }
      Promise.all(promises).then(result => {
        resolve(result)
      })
    }

    fileReader.readAsArrayBuffer(file)
  })
}

export function numOfPages(file) {
  return new Promise(resolve => {
    let fileReader = new FileReader()
    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker
    PDFJS.disableWorker = true

    fileReader.onload = async function () {
      let typedarray = new Uint8Array(this.result)

      const loadingTask = PDFJS.getDocument(typedarray)
      const pdf = await loadingTask.promise

      resolve(pdf.numPages)
    }

    fileReader.readAsArrayBuffer(file)
  })
}